import { Button, ButtonVariant, PageHeader } from '@egw/components'
import { WEALTH_ROUTES } from '@egw/constants'
import { Trans, useTranslation } from '@egw/i18n'
import { useRouter } from '@egw/router'
import { CheckCircleIcon } from '@heroicons/react/24/outline'
import { type FC } from 'react'

export const WiresSuccessPage: FC = () => {
  const { t } = useTranslation('features-transfer')

  const { navigate } = useRouter()
  const goToTransfer = (): void => {
    navigate(WEALTH_ROUTES.TRANSFER.path)
  }
  return (
    <>
      <PageHeader title={t('wire_transfer_success.title')} />
      <div className="egw-container flex flex-col max-md:justify-between gap-2 h-full">
        <div className="flex flex-col gap-2">
          <div>
            <div className="relative right-1 mb-2">
              <CheckCircleIcon className="h-[4rem] w-[4rem] stroke-textSuccess stroke-[.5px] mb-sm" />
            </div>
            <p className="text-textSuccess text-2xl font-light">{t('wire_transfer_success.transfer_received')}</p>
          </div>
          <div className="text-meta text-base">
            <Trans t={t} i18nKey="wire_transfer_success.p" components={{ 1: <br /> }} />
          </div>
        </div>
        <Button
          id="wireSuccessDone"
          variant={ButtonVariant.Secondary}
          onClick={goToTransfer}
          className="md:w-fit md:mt-8"
        >
          {t('transfer.done')}
        </Button>
      </div>
    </>
  )
}
